// extracted by mini-css-extract-plugin
module.exports = {"gif":"gif-module--gif--1FBgw","gif__caption":"gif-module--gif__caption--1x-89"};